// extracted by mini-css-extract-plugin
export default {"text":"style_text__O3cCX","modal_content":"style_modal_content__5Fvkp","btns":"style_btns__QpUHK"};